<ul
  ngbNav
  #nav="ngbNav"
  [activeId]="active$ | async"
  (activeIdChange)="onActiveChange($event)"
  class="nav nav-tabs flex-nowrap overflow-auto no-scrollbar justify-content-center justify-content-md-start"
>
  <ng-container *ngFor="let item of items; let i = index">
    <li
      *epcDynamicComponentIf="item.if"
      [disabled]="item.disabled | dynamicOperationIf"
      epcDynamicElementsTooltip
      [tooltip]="item.tooltip"
      [tooltipEnabled]="item.tooltipEnabled"
      [ngbNavItem]="i"
      [destroyOnHide]="true"
      class="flex-grow-1 flex-md-grow-0"
    >
      <a
        ngbNavLink
        data-e2e="tab-item"
        class="text-center text-truncate"
        [routerLink]="item.label.routerLink"
      >
        <ng-container *ngFor="let child of item.label.children">
          <ng-container *epcDynamicComponentIf="child.if">
            <ng-template
              [epcDynamicComponent]="{
                contentTypeId: child.contentTypeId
              }"
              [inputs]="child.inputs"
              [styles]="child.styles"
              [children]="child.children"
            ></ng-template>
          </ng-container>
        </ng-container>
      </a>
      <ng-template ngbNavContent>
        <ng-template
          *ngIf="item.content"
          [epcDynamicComponent]="{
            contentTypeId: item.content.contentTypeId
          }"
          [inputs]="item.content.inputs"
          [styles]="item.content.styles"
          [children]="item.content.children"
        ></ng-template>
      </ng-template>
    </li>
  </ng-container>
  <li class="ml-auto d-flex align-items-center">
    <ng-content></ng-content>
  </li>
</ul>

<div [ngbNavOutlet]="nav" class="mt-3"></div>
